<div class="chart-container" [style.height]="height">
    <h3 *ngIf="chartTitle" class="chart-title">{{ chartTitle }}</h3>
    <canvas baseChart [type]="pieChartType" [data]="chartData" [options]="chartOptions">
    </canvas>
</div>